import Button from "../Button";
import {useState, useRef, useEffect, useContext} from "react";
import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";
import {LiaSmsSolid} from "react-icons/lia";
import {TransactionalCreditDefaults} from "../../tools/defaults/transactionalCredit/TransactionalCreditDefaults";
import LoadingScreen from "../LoadingScreen";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import {persianToEnglish} from "../../tools/helpers";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const VerifyOTP = () => {
    const [loading, setLoading] = useState(true);
    const [requestLoading, setRequestLoading] = useState(false);
    const transactionalCreditContext = useContext(TransactionalCreditContext)
    const [inputValues, setInputValues] = useState(['', '', '', '', '']);
    const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef()];
    const [disabled, setDisabled] = useState(true);
    const timerCount = 600
    const [timerDuration, setTimerDuration] = useState(timerCount);
    const [showRequestOTP, setShowRequestOTP] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false)
    const handleRequestOTP = (clicked) => {
        if (clicked) {
            setRequestLoading(true)

        }
        handleGenerateUuid("RequestOTP", transactionalCreditContext.token).then(uuid => {
            if (uuid) {
                Api.post(REQUEST_URLS.TRANSACTIONAL_CREDIT.REQUEST_OTP, {
                    "pid": transactionalCreditContext.pid,
                    "uuid": uuid,
                }, {
                    headers: {
                        "Authorization": `Bearer ${transactionalCreditContext.token}`
                    },
                }).then(response => {
                    const {hasError, status, data, message} = response;
                    if (hasError) {

                        setLoading(false);
                        setRequestLoading(false);
                        transactionalCreditContext.handleError({
                            status: status,
                            message,
                            data,
                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message: message,
                                    showCancelButton: true,
                                    cancelButtonText: status===266 ? 'بستن':'تلاش مجدد',
                                    onCancel: () => {
                                        if(status!==266){
                                            handleRequestOTP(clicked)
                                        }else {
                                            handleShowRequestOTP(timerCount)
                                            setRequestLoading(false)
                                        }
                                    }
                                })
                                /*handleRequestOTP(clicked)*/
                            }
                        })
                    } else {
                        if(data.fetch_needed){
                            transactionalCreditContext.handleGetProcess(transactionalCreditContext.pid);
                            setLoading(false);
                            setRequestLoading(false);
                        }else {
                            handleShowRequestOTP();
                            setLoading(false);
                            setRequestLoading(false);
                        }

                    }
                })
            }
        })


    }
    const handleVerifyOTP = () => {
        setSubmitLoading(true)
        const OTP = inputValues.join('');
        handleGenerateUuid("VerifyOTP", transactionalCreditContext.token).then(uuid => {
            Api.post(REQUEST_URLS.TRANSACTIONAL_CREDIT.VERIFY_OTP, {
                pid: transactionalCreditContext.pid,
                uuid,
                "OTP":persianToEnglish(OTP),
            }, {
                headers: {
                    "Authorization": `Bearer ${transactionalCreditContext.token}`
                },
            }).then(response => {
                const {hasError, status, data, message} = response;
                if (hasError) {
                    transactionalCreditContext.handleError({
                        status: status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    setInputValues(['', '', '', '', '']);
                                    setSubmitLoading(false)
                                }
                            })

                        }
                    })
                } else {
                    transactionalCreditContext.handleGetProcess(transactionalCreditContext.pid)
                }
            }).catch(e => {

            })
        })


    }
    useEffect(() => {
        if (transactionalCreditContext.components.current_component.name === TransactionalCreditDefaults.OTP_REQUEST) {
            setLoading(true)
            handleRequestOTP()
        } else {
            if (transactionalCreditContext.process.sent_otp_time) {
                const currentTimestamp = new Date().getTime() / 1000;

                const difference = currentTimestamp - transactionalCreditContext.process.sent_otp_time;

                if (Math.floor(difference) < 600) {
                    handleShowRequestOTP(Math.floor(600-difference))
                } else {
                    setLoading(true);
                    handleRequestOTP(true)
                }
            }
            setLoading(false)
        }

    }, [])
    const handleShowRequestOTP = (time) => {

        if (time) {
            setTimerDuration(time)
        } else {
            setTimerDuration(timerCount)
        }
        setShowRequestOTP(false);
        if (!showRequestOTP) {
            const intervalId = setInterval(() => {
                // Decrement countdown by 1
                setTimerDuration((prevCountdown) => prevCountdown - 1);
            }, 1000); // Update every 1000ms (1 second)

            // Clean up the interval when the component unmounts
            return () => clearInterval(intervalId);
        }

    }
    useEffect(() => {
        if (timerDuration === 0) {
            setShowRequestOTP(true);
        } else {

        }
    }, [timerDuration])

    useEffect(() => {
        if (inputValues.join("").length === inputValues.length) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [inputValues])
    const handleChange = (index, value) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = value;
        setInputValues(newInputValues);
        if (value && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };
    const handleKeyUp = (e, index) => {
        if (e.code === "Backspace") {
            if (index > 0 && e.target.value === "") {
                inputRefs[index - 1].current.focus()
            }
        }
    }
    function formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
    }
    if (loading && !requestLoading) {
        return <div><LoadingScreen text={'در حال ارسال کد اعتبار سنجی'}/></div>
    }
    return <div className="pt-10">
        <div className="w-11/12 md:w-6/12 lg:w-4/12 mx-auto mt-10   p-5 rounded-lg  bg-white">

            <div className="w-full border-b flex flex-col items-center justify-center  p-5  mb-5 ">
                <div
                    className="p-3 w-16 h-16 bg-green-100 flex flex-col items-center  mb-2 justify-center  rounded-full">
                    <LiaSmsSolid className="text-3xl text-green-700"/>
                </div>
                <h1 className="  text-center  font-bold ">پیامک حاوی کد اعتبار سنجی ارسال شد</h1>
                <p className="text-sm px-2 mx-auto w-full text-center ">کد اعتبار سنجی ارسال شده به
                    شماره {transactionalCreditContext.process.platform_user} را وارد نمایید.</p>
            </div>

            <div dir="ltr" className="flex justify-center mt-5   gap-3  items-center">
                {inputValues.map((value, index) => (
                    <div key={index}
                         className={` w-16 border-b border-gray-300  text-lg      flex justify-center items-center ${inputValues[index].length > 0 ? 'bg-gray-100 border-green-300' : 'bg-gray-50'}`}>
                        <input
                            onKeyUp={(e) => handleKeyUp(e, index)}
                            ref={inputRefs[index]}
                            type="tel"
                            maxLength={1}
                            className={"w-full focus:outline-none focus:border-green-500 focus:border  bg-transparent p-5 h-full text-center"}
                            value={value}
                            onChange={(e) => {
                                handleChange(index, e.target.value)
                            }}
                        />
                    </div>
                ))}
            </div>

            <div className="w-full mt-5 grid grid-cols-2 gap-2 border-t pt-5">
                <Button loading={requestLoading} disabled={!showRequestOTP || submitLoading}
                        onClick={() => handleRequestOTP(true)}
                        className="w-full text-sm border"
                        theme="link"
                        rounded="rounded-lg">{showRequestOTP ? 'درخواست کد' : `  ${formatTime(timerDuration)}`}</Button>
                <Button loading={submitLoading} onClick={handleVerifyOTP} disabled={disabled || requestLoading}
                        className="w-full text-sm" theme="green"
                        rounded="rounded-lg">مرحله
                    بعد</Button>

            </div>
        </div>
    </div>
}
export default VerifyOTP;